module.exports = __webpack_public_path__ + "static/img/004.7dcd65bc.png";